import { render } from "./ConsultarUsuarios.vue?vue&type=template&id=6faa6638"
import script from "./ConsultarUsuarios.vue?vue&type=script&lang=js"
export * from "./ConsultarUsuarios.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__